export enum UserRole {
  STANDARD = 1,
  ADMIN = 9,
  OPERATIONS_ADMIN = 3,
}

export const UserRoleLabels: Record<UserRole, string> = {
  [UserRole.STANDARD]: "Standard User",
  [UserRole.ADMIN]: "Admin",
  [UserRole.OPERATIONS_ADMIN]: "Operations Admin",
};
